exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pl-login-status label {\n    margin-right: .5em;\n    vertical-align: middle;\n}\n.pl-login-status-btn {\n    font-size: 1.5em;\n    margin-right: .3em;\n    cursor: pointer;\n    vertical-align: middle;\n}\n.pl-login-status-btn {\n    -webkit-transition: all .2s ease-in;\n    transition: all .2s ease-in;\n}\n.pl-login-status {\n    color: #CBCBCB;\n}\n.pl-login-status-btn:hover {\n    color: #fff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login-status/login-status.component.css
// module id = ../../../../../src/app/login-status/login-status.component.css
// module chunks = main